// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1JFxM","additionalInfo":"AgreementModal_additionalInfo__gtB1P"};